import type { SVGProps } from 'react';
const SvgPermDeviceInformation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#perm_device_information_svg__a)">
      <path
        fill="currentColor"
        d="M13 7h-2v2h2V7Zm0 4h-2v6h2v-6Zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99ZM17 19H7V5h10v14Z"
      />
    </g>
    <defs>
      <clipPath id="perm_device_information_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPermDeviceInformation;
